import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11 0C4.9 0 0 4.79 0 10.753s4.9 10.754 11 10.754 11-4.79 11-10.754S17.1 0 11 0m0 19.551c-5 0-9-3.91-9-8.798s4-8.798 9-8.798 9 3.91 9 8.798-4 8.798-9 8.798m.7-13.393c-.1-.097-.2-.195-.3-.195-.2-.098-.5-.098-.8 0-.1.098-.2.098-.3.195l-4 3.91a.93.93 0 0 0 0 1.37c.4.39 1 .39 1.4 0L10 9.189v5.474c0 .587.4.978 1 .978s1-.391 1-.978V9.189l2.3 2.248c.2.196.5.294.7.294s.5-.098.7-.294a.93.93 0 0 0 0-1.368z"
    }, null, -1)
  ]))]))
}
export default { render: render }